export default __webpack_public_path__ + "2aa64908fdb1da8519083f3dccd40753.svg";